import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../NextJsHosting.css';

const NextJsHostingHe = () => {
    const scrollToPricing = (e) => {
        e.preventDefault();
        const pricingSection = document.getElementById('pricing');
        if (pricingSection) {
            const headerOffset = 100;
            const elementPosition = pricingSection.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    };

    return (
        <div dir="rtl">
            <Helmet>
                {/* Primary Meta Tags */}
                <title>אחסון Next.js - פריסת SSR/SSG מהירה עם Edge CDN | Epicfinal</title>
                <meta name="title" content="אחסון Next.js - פריסת SSR/SSG מהירה עם Edge CDN | Epicfinal" />
                <meta name="description" content="פרסו אפליקציות Next.js החל מ-₪19.90 לחודש. תמיכה ב-SSR ו-SSG, Cloudflare Edge CDN, סקיילביליות אוטומטית, אינטגרציית Git ואופטימיזציית תמונות. בנוי למפתחי React." />
                <meta name="keywords" content="אחסון Next.js, פריסת Next.js, אחסון React, אחסון SSR, אחסון SSG, אלטרנטיבה ל-Vercel, אחסון ענן Next.js, Next.js serverless, פונקציות edge, Next.js CDN, אחסון Jamstack, אחסון Node.js" />
                <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
                <meta name="author" content="Epicfinal" />
                <link rel="canonical" href="https://epicfinal.com/he/nextjs-hosting" />

                {/* Language & Locale */}
                <html lang="he" />
                <meta property="og:locale" content="he_IL" />
                <link rel="alternate" href="https://epicfinal.com/nextjs-hosting" hrefLang="en" />
                <link rel="alternate" href="https://epicfinal.com/he/nextjs-hosting" hrefLang="he" />

                {/* Open Graph / Facebook */}
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://epicfinal.com/he/nextjs-hosting" />
                <meta property="og:title" content="אחסון Next.js - SSR/SSG עם Edge CDN | Epicfinal" />
                <meta property="og:description" content="פרסו אפליקציות Next.js החל מ-₪19.90 לחודש. תמיכה ב-SSR ו-SSG, Cloudflare Edge CDN, סקיילביליות אוטומטית ופריסה מיידית." />
                <meta property="og:image" content="https://epicfinal.com/android-chrome-512x512.png" />
                <meta property="og:image:alt" content="Epicfinal אחסון Next.js - פריסת React מודרנית" />
                <meta property="og:site_name" content="Epicfinal" />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:url" content="https://epicfinal.com/he/nextjs-hosting" />
                <meta name="twitter:title" content="אחסון Next.js - פריסת SSR/SSG מהירה | Epicfinal" />
                <meta name="twitter:description" content="פרסו אפליקציות Next.js החל מ-₪19.90 לחודש. SSR ו-SSG, Edge CDN ואינטגרציית Git." />
                <meta name="twitter:image" content="https://epicfinal.com/android-chrome-512x512.png" />

                {/* Schema.org Structured Data */}
                <script type="application/ld+json">{`
                    {
                        "@context": "https://schema.org",
                        "@type": "WebPage",
                        "name": "אחסון Next.js - פריסת SSR/SSG מהירה עם Edge CDN",
                        "description": "פרסו אפליקציות Next.js עם אחסון אופטימלי, תמיכה ב-SSR ו-SSG, Cloudflare Edge CDN, סקיילביליות אוטומטית ואינטגרציית Git.",
                        "url": "https://epicfinal.com/he/nextjs-hosting",
                        "provider": {
                            "@type": "Organization",
                            "name": "Epicfinal",
                            "url": "https://epicfinal.com"
                        },
                        "breadcrumb": {
                            "@type": "BreadcrumbList",
                            "itemListElement": [
                                {
                                    "@type": "ListItem",
                                    "position": 1,
                                    "name": "בית",
                                    "item": "https://epicfinal.com/he"
                                },
                                {
                                    "@type": "ListItem",
                                    "position": 2,
                                    "name": "אחסון Next.js",
                                    "item": "https://epicfinal.com/he/nextjs-hosting"
                                }
                            ]
                        }
                    }
                `}</script>
            </Helmet>

            <div className="nextjs-hosting-page">
                {/* Hero Section */}
                <section className="nextjs-hero">
                    <div className="container">
                        <div className="nextjs-hero-content">
                            <div className="nextjs-logo-badge">
                                <svg viewBox="0 0 180 180" width="60" height="60">
                                    <mask id="mask0" mask-type="alpha">
                                        <circle cx="90" cy="90" r="90" fill="black" />
                                    </mask>
                                    <g mask="url(#mask0)">
                                        <circle cx="90" cy="90" r="90" fill="black" />
                                        <path d="M149.508 157.52L69.142 54H54v71.97h12.114V69.384l73.885 95.461a90.304 90.304 0 009.509-7.325z" fill="white" />
                                        <path d="M115 54h12v72h-12z" fill="white" />
                                    </g>
                                </svg>
                            </div>
                            <h1 className="nextjs-hero-title nextjs-hero-title-he">
                                אחסון Next.js
                            </h1>
                            <p className="nextjs-hero-subtitle">
                                פריסת אפליקציות React מודרניות בקנה מידה רחב
                            </p>
                            <p className="nextjs-hero-description">
                                אחסון מהיר במיוחד המותאם ל-Next.js עם סקיילביליות אוטומטית, פונקציות edge ו-CDN גלובלי. בנו ופרסו בשניות.
                            </p>
                            <div className="nextjs-hero-buttons">
                                <a href="#pricing" onClick={scrollToPricing} className="btn-nextjs btn-primary">
                                    צפו בתוכניות ומחירים
                                </a>
                                <Link to="/contact1" className="btn-nextjs btn-secondary">
                                    צרו קשר עם המכירות
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Features Section */}
                <section className="nextjs-features">
                    <div className="container">
                        <div className="nextjs-section-header">
                            <h2>בנוי עבור Next.js</h2>
                            <p>כל מה שאפליקציית ה-Next.js שלכם צריכה כדי לשגשג</p>
                        </div>
                        <div className="nextjs-features-grid">
                            <div className="nextjs-feature-card">
                                <div className="nextjs-feature-icon">
                                    <i className="las la-rocket"></i>
                                </div>
                                <h3>פריסה מיידית</h3>
                                <p>פרסו מ-Git בשניות עם בנייה אוטומטית ואפס הגדרות.</p>
                            </div>
                            <div className="nextjs-feature-card">
                                <div className="nextjs-feature-icon">
                                    <i className="las la-globe"></i>
                                </div>
                                <h3>Cloudflare CDN</h3>
                                <p>נכסים סטטיים מוגשים מ-200+ מיקומי edge ברחבי העולם לשיהוי נמוך במיוחד.</p>
                            </div>
                            <div className="nextjs-feature-card">
                                <div className="nextjs-feature-icon">
                                    <i className="las la-bolt"></i>
                                </div>
                                <h3>Edge Functions</h3>
                                <p>הרצת פונקציות serverless ב-edge לביצועים מקסימליים.</p>
                            </div>
                            <div className="nextjs-feature-card">
                                <div className="nextjs-feature-icon">
                                    <i className="las la-expand-arrows-alt"></i>
                                </div>
                                <h3>סקיילביליות</h3>
                                <p>צמיחה אוטומטית לטיפול בכל קפיצת תעבורה.</p>
                            </div>
                            <div className="nextjs-feature-card">
                                <div className="nextjs-feature-icon">
                                    <i className="las la-code-branch"></i>
                                </div>
                                <h3>אינטגרציית Git</h3>
                                <p>חיבור ל-GitHub, GitLab או Bitbucket לפריסות אוטומטיות.</p>
                            </div>
                            <div className="nextjs-feature-card">
                                <div className="nextjs-feature-icon">
                                    <i className="las la-chart-line"></i>
                                </div>
                                <h3>אנליטיקה</h3>
                                <p>אנליטיקה בזמן אמת לניטור ביצועים והתנהגות משתמשים.</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Performance Section */}
                <section className="nextjs-performance">
                    <div className="container">
                        <div className="nextjs-section-header">
                            <h2>ביצועים ללא פשרות</h2>
                            <p>מהירות שהמשתמשים אוהבים</p>
                        </div>
                        <div className="nextjs-performance-grid">
                            <div className="nextjs-perf-card">
                                <div className="nextjs-perf-icon">
                                    <i className="las la-tachometer-alt"></i>
                                </div>
                                <h3>SSR & SSG</h3>
                                <p>תמיכה מלאה ב-Server-Side Rendering ו-Static Site Generation</p>
                            </div>
                            <div className="nextjs-perf-card">
                                <div className="nextjs-perf-icon">
                                    <i className="las la-compress"></i>
                                </div>
                                <h3>אופטימיזציה אוטומטית</h3>
                                <p>אופטימיזציית תמונות, פיצול קוד וטעינה עצלה מובנים</p>
                            </div>
                            <div className="nextjs-perf-card">
                                <div className="nextjs-perf-icon">
                                    <i className="las la-network-wired"></i>
                                </div>
                                <h3>רשת Edge של Cloudflare</h3>
                                <p>תוכן מוגש ממיקום ה-edge הקרוב ביותר למשתמשים שלכם</p>
                            </div>
                            <div className="nextjs-perf-card">
                                <div className="nextjs-perf-icon">
                                    <i className="las la-mobile"></i>
                                </div>
                                <h3>מותאם למובייל</h3>
                                <p>אופטימיזציה למכשירים ניידים עם שיפור הדרגתי</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Pricing Plans Section */}
                <section className="nextjs-pricing" id="pricing">
                    <div className="container">
                        <div className="nextjs-section-header">
                            <h2>תוכניות אחסון Next.js</h2>
                            <p>פרסו את אפליקציות ה-Next.js שלכם עם התשתית הטובה ביותר</p>
                        </div>
                        <div className="nextjs-pricing-grid">
                            {/* Starter Plan */}
                            <div className="nextjs-pricing-card">
                                <div className="nextjs-pricing-header">
                                    <h3>Next.js Starter</h3>
                                    <p className="nextjs-pricing-tagline">מושלם לפרויקטים אישיים ואפליקציות Next.js קטנות</p>
                                </div>
                                <div className="nextjs-pricing-price">
                                    <span className="nextjs-price-amount">₪19.90</span>
                                    <span className="nextjs-price-period">₪ / חודשי</span>
                                </div>
                                <ul className="nextjs-pricing-features">
                                    <li><i className="las la-check"></i> <strong>אתר Next.js אחד</strong></li>
                                    <li><i className="las la-check"></i> 5GB NVMe SSD אחסון</li>
                                    <li><i className="las la-check"></i> תעבורה ללא הגבלה (שימוש הוגן)</li>
                                    <li><i className="las la-check"></i> תמיכה ב-SSR & SSG</li>
                                    <li><i className="las la-check"></i> פריסות אוטומטיות</li>
                                    <li><i className="las la-check"></i> הגנה מפני תוכנות זדוניות</li>
                                    <li><i className="las la-check"></i> תעודות SSL חינם</li>
                                    <li><i className="las la-check"></i> אינטגרציית Cloudflare CDN</li>
                                    <li><i className="las la-check"></i> אינטגרציית Git</li>
                                    <li><i className="las la-check"></i> משתני סביבה</li>
                                </ul>
                                <a href="https://my.epicfinal.com/index.php?rp=/store/cloud-web-hosting/s1-web-starter&language=hebrew&currency=2"
                                    className="nextjs-pricing-btn" target="_blank" rel="noopener noreferrer">
                                    מתחילים עכשיו
                                </a>
                            </div>

                            {/* Pro Plan */}
                            <div className="nextjs-pricing-card featured">
                                <div className="nextjs-pricing-badge">הכי טוב למפתחים</div>
                                <div className="nextjs-pricing-header">
                                    <h3>Next.js Pro</h3>
                                    <p className="nextjs-pricing-tagline">תכונות מתקדמות למפתחי Next.js מקצועיים</p>
                                </div>
                                <div className="nextjs-pricing-price">
                                    <span className="nextjs-price-amount">₪31.40</span>
                                    <span className="nextjs-price-period">₪ / חודשי</span>
                                </div>
                                <ul className="nextjs-pricing-features">
                                    <li><i className="las la-check"></i> <strong>עד 3 אתרי Next.js</strong></li>
                                    <li><i className="las la-check"></i> 15GB NVMe SSD אחסון</li>
                                    <li><i className="las la-check"></i> תעבורה ללא הגבלה (שימוש הוגן)</li>
                                    <li><i className="las la-check"></i> SSR & ISR מתקדמים</li>
                                    <li><i className="las la-check"></i> Edge Functions</li>
                                    <li><i className="las la-check"></i> פריסות תצוגה מקדימה</li>
                                    <li><i className="las la-check"></i> דומיינים מותאמים אישית</li>
                                    <li><i className="las la-check"></i> מטמון מתקדם</li>
                                    <li><i className="las la-check"></i> אופטימיזציית תמונות</li>
                                    <li><i className="las la-check"></i> אנליטיקה וניטור</li>
                                    <li><i className="las la-check"></i> תור בנייה בעדיפות</li>
                                </ul>
                                <a href="https://my.epicfinal.com/index.php?rp=/store/cloud-web-hosting/epicfinal-cloud-web-pro&language=hebrew&currency=2"
                                    className="nextjs-pricing-btn" target="_blank" rel="noopener noreferrer">
                                    מתחילים עכשיו
                                </a>
                            </div>

                            {/* Business Plan */}
                            <div className="nextjs-pricing-card">
                                <div className="nextjs-pricing-header">
                                    <h3>Next.js Business</h3>
                                    <p className="nextjs-pricing-tagline">אחסון ברמה ארגונית לסוכנויות ואפליקציות גדולות</p>
                                </div>
                                <div className="nextjs-pricing-price">
                                    <span className="nextjs-price-amount">₪55.90</span>
                                    <span className="nextjs-price-period">₪ / חודשי</span>
                                </div>
                                <ul className="nextjs-pricing-features">
                                    <li><i className="las la-check"></i> <strong>עד 10 אתרי Next.js</strong></li>
                                    <li><i className="las la-check"></i> 40GB NVMe SSD אחסון</li>
                                    <li><i className="las la-check"></i> תעבורה ללא הגבלה (~150 אלף ביקורים בחודש)</li>
                                    <li><i className="las la-check"></i> תמיכה בריבוי דיירים (Multi-Tenant)</li>
                                    <li><i className="las la-check"></i> Edge Functions מתקדמות</li>
                                    <li><i className="las la-check"></i> שיתוף פעולה צוותי</li>
                                    <li><i className="las la-check"></i> משאבי בנייה ייעודיים</li>
                                    <li><i className="las la-check"></i> תמיכה בעדיפות</li>
                                    <li><i className="las la-check"></i> אבטחה מתקדמת</li>
                                    <li><i className="las la-check"></i> תשתית בהתאמה אישית</li>
                                    <li><i className="las la-check"></i> מושלם לפרויקטים של סוכנות</li>
                                </ul>
                                <a href="https://my.epicfinal.com/index.php?rp=/store/cloud-web-hosting/epicfinal-business&language=hebrew&currency=2"
                                    className="nextjs-pricing-btn" target="_blank" rel="noopener noreferrer">
                                    מתחילים עכשיו
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Stats Section */}
                <section className="nextjs-stats">
                    <div className="container">
                        <div className="nextjs-stats-grid">
                            <div className="nextjs-stat">
                                <div className="nextjs-stat-number">&lt;100ms</div>
                                <div className="nextjs-stat-label">זמן תגובה</div>
                            </div>
                            <div className="nextjs-stat">
                                <div className="nextjs-stat-number">200+</div>
                                <div className="nextjs-stat-label">מיקומי Edge</div>
                            </div>
                            <div className="nextjs-stat">
                                <div className="nextjs-stat-number">99.99%</div>
                                <div className="nextjs-stat-label">זמינות SLA</div>
                            </div>
                            <div className="nextjs-stat">
                                <div className="nextjs-stat-number">∞</div>
                                <div className="nextjs-stat-label">סקיילביליות אוטומטית</div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* CTA Section */}
                <section className="nextjs-cta">
                    <div className="container">
                        <div className="nextjs-cta-content">
                            <h2>פרסו את אפליקציית ה-Next.js שלכם היום</h2>
                            <p>חוו את פלטפורמת האחסון המהירה ביותר לאפליקציות ווב מודרניות</p>
                            <div className="nextjs-cta-buttons">
                                <Link to="/pricing-he" className="btn-nextjs btn-light">
                                    צפו במחירים
                                </Link>
                                <Link to="/contact1" className="btn-nextjs btn-outline">
                                    צרו קשר
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default NextJsHostingHe;
